import React from 'react';

import { UsersTable } from '../components/UsersTable/UsersTable';
import { useUsers } from '../hooks/useUsers';

import type { FC } from 'react';

export const Users: FC = () => {
  const { data: users = [], isLoading } = useUsers();

  return <UsersTable users={users} loading={isLoading} />;
};
